import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import { BottomSectionContactUs } from "../../containers/CallCenterPage/bottomsectioncontactus";
import { BusinessInquiriesForm } from "../../components/form";
import { ContactUsDiv } from "../../components/staffinghomepage/StaffingHomepage";
import { ContactUsText } from "../../components/staffinghomepage/StaffingHomepage";
import { ContactUsButton } from "../../components/staffinghomepage/StaffingHomepage";
import GinaVideo from "../../images/video/ExpedientStaffing_V8.mp4";
import { ImgWrap } from "../about";
import { Video } from "../about";

const GetFoodContainer = styled.div`
    margin-top: 90px;
`;

const GetFoodRedBox = styled.div`
    background-color: #B55959;
    padding-top: 5%;
    padding-bottom: 5%;
`;

const GetFoodHeader = styled.h2`
    color: white;
    font-family: Sunflower;
    font-size: 26px;

    @media screen and (max-width: 768px){
        font-size: 16px;
    }
`;

const EmergencyResponse = styled.h2`
    color: white;
    font-size: 20px;
    display: inline-block;
    font-weight: 300;

    @media screen and (max-width: 768px){
        font-size: 12px;
    }
`;

const GetFoodSubheader = styled.h3`
    color: white;
    font-family: Roboto;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    margin-bottom: 0;

    @media screen and (max-width: 768px){
        font-size: 12px;
    }
`;


export function GetFoodNYC() {
    const formRef = useRef(null);
    const [isFormVisible, setIsFormVisible] = useState(false);

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible)
    }

    useEffect(() => {
        const handleDocumentClick = (e) => {
          if (isFormVisible && formRef.current && !formRef.current.contains(e.target)) {
            toggleFormVisibility(); // Close the form if it's visible and the click is outside
          }
        };
    
        document.addEventListener('click', handleDocumentClick);
    
        return () => {
          document.removeEventListener('click', handleDocumentClick);
        };
    }, [isFormVisible]);


    return(
        <GetFoodContainer id="get-food-nyc">
            <GetFoodRedBox>
                <GetFoodHeader>GetFoodNYC | <EmergencyResponse>Covid-19 Emergency Response</EmergencyResponse>
                </GetFoodHeader>
                <GetFoodSubheader>a proof of concept case study</GetFoodSubheader>
            </GetFoodRedBox>
            <BottomSectionContactUs />
            <ImgWrap>
                <Video width="100%" controls disablepictureinpicture controlslist="nodownload" >
                    <source src={GinaVideo} type="video/mp4"/>
                    Sorry, Your browser doesn't support videos.
                </Video>
            </ImgWrap>
            <ContactUsDiv style={{ paddingTop: '90px'}}>
                <ContactUsText>Ready to revamp your workforce? Reach out!</ContactUsText>
                <ContactUsButton onClick={toggleFormVisibility}>Contact Us</ContactUsButton>
                {isFormVisible && (
                    <div ref={formRef}>
                        <BusinessInquiriesForm />
                    </div>
                )}
            </ContactUsDiv>
        </GetFoodContainer>
    )
    
}